import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { GlobalsService } from "@services";
import { Router } from "@angular/router";

@Component({
    selector: "landing",
    template: ``,
    standalone: false
})
export class LandingComponent implements OnInit {
	constructor(private location: Location, private router: Router) { }

	ngOnInit() {
		if (GlobalsService.isAdmin === true) {
			this.router.navigate(["/globalAdmin"]);
		}
		else if (GlobalsService.companySettings.isCorporateAccount && GlobalsService.userInfo.isCorporateAdmin)
			this.router.navigate([this.firstPermittedPage(LandingComponent.corporatePages)]);
		else if (GlobalsService.companySettings.isCorporateAccount && GlobalsService.userInfo.isDispatch)
			this.router.navigate([this.firstPermittedPage(LandingComponent.dispatchPages)]);
		else if (GlobalsService.isLoggedIn === true) {
			this.router.navigate(["/dashboard"]);
		}
	}

	// Corporate/dispatch users land on the first page their permissions allow, in side-menu order. (The
	// Dashboard used to be assumed; it is a permission now and can be off.)
	private static readonly corporatePages: { url: string, feature: string, action: string }[] = [
		{ url: "/corporate-view", feature: "Corporate", action: "Dashboard" },
		{ url: "/franchise-page-view/jobs", feature: "Jobs", action: "View" },
		{ url: "/franchise-page-view/invoices", feature: "Invoices", action: "View" },
		{ url: "/franchise-page-view/payments", feature: "Payments", action: "View" },
		{ url: "/franchise-page-view/schedule", feature: "Appointments", action: "View" },
		{ url: "/franchise-page-view/businessDevelopment", feature: "BusinessDevelopmentAccounts", action: "View" },
		{ url: "/corporate-commissions", feature: "Commissions", action: "ShowAll" },
		{ url: "/corporate-tasks", feature: "Tasks", action: "View" },
		{ url: "/corporate-dashboard/revenue", feature: "Corporate", action: "KPIs" },
		{ url: "/corporate-reporting/jobMasterReport", feature: "Corporate", action: "Reports" },
		{ url: "/setup/priceBooks", feature: "Corporate", action: "PriceBook" },
		{ url: "/corporate-users", feature: "Corporate", action: "Users" },
		{ url: "/dispatch-users", feature: "Corporate", action: "DispatchUsers" },
		{ url: "/corporate-open-api/keys", feature: "Corporate", action: "OpenApi" },
	];

	private static readonly dispatchPages: { url: string, feature: string, action: string }[] = [
		{ url: "/franchise-page-view/jobs", feature: "Jobs", action: "View" },
		{ url: "/franchise-page-view/schedule", feature: "Appointments", action: "View" },
		{ url: "/franchise-page-view/businessDevelopment", feature: "BusinessDevelopmentAccounts", action: "View" },
		{ url: "/corporate-tasks", feature: "Tasks", action: "View" },
		{ url: "/assignments", feature: null, action: null },
	];

	private firstPermittedPage(pages: { url: string, feature: string, action: string }[]): string {
		const page = pages.find(p => !p.feature || GlobalsService.checkPermission(p.feature, p.action));
		// Nothing permitted at all: the user-settings page is always reachable and says so better than a 404.
		return page?.url ?? "/userSettings";
	}
}
